import { Box, Divider, Typography } from "@mui/material";
import { Link } from "react-router-dom";

export function FAQSection() {
  return (
    <Box display="flex" width="100%" justifyContent="center">
      <Box display="flex" flexDirection="column" width="1000px">
        <Typography fontWeight="bold" variant="h5" sx={{ my: 2 }}>
          よくあるご質問
        </Typography>

        <Box border={1} p={2} borderColor="#ddd" my={2}>
          <Typography fontWeight="bold" variant="h6">
            Q. ランチの人気No.1プランは？ (2023/12/22 時点)
          </Typography>
          <Divider sx={{ borderStyle: "dashed", my: 2 }} />
          <Typography
            color="#af9b65"
            variant="h6"
            component={Link}
            to="#"
            sx={{
              px: 2,
              textDecoration: "none",
              "&:hover": {
                opacity: 0.8,
              },
            }}
          >
            A. 【和食
            天婦羅御膳】海老や白身魚、季節の野菜など天婦羅を堪能＋シャンパン含む1杯
          </Typography>
        </Box>

        <Box border={1} p={2} borderColor="#ddd" my={2}>
          <Typography fontWeight="bold" variant="h6">
            Q. ディナーの人気No.1プランは？ (2023/12/22 時点)
          </Typography>
          <Divider sx={{ borderStyle: "dashed", my: 2 }} />
          <Typography
            color="#af9b65"
            variant="h6"
            component={Link}
            to="#"
            sx={{
              px: 2,
              textDecoration: "none",
              "&:hover": {
                opacity: 0.8,
              },
            }}
          >
            A.
            【イタリアン】前菜、魚料理、パスタ、選べるメインなど全7品＋乾杯グラスシャンパン
          </Typography>
        </Box>

        <Box border={1} p={2} borderColor="#ddd" my={2}>
          <Typography fontWeight="bold" variant="h6">
            Q. この店舗の最寄りの駅からの行き方は
          </Typography>
          <Divider sx={{ borderStyle: "dashed", my: 2 }} />
          <Typography color="#af9b65" variant="h6" sx={{ px: 2 }}>
            A.{" "}
            <span style={{ color: "black" }}>
              神谷町駅
              3番出口を出て左に約300ｍ直進。西新橋三丁目の交差点左手角の「愛宕グリーンヒルズMORIタワー」の42階です。
            </span>
          </Typography>
        </Box>
      </Box>
    </Box>
  );
}
